export default {"src":"/_next/static/media/apartment.80bed514.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};